import { FC, useState } from 'react';

import styled from 'styled-components';

import { useTranslation } from '@crehana/i18n';
import { PrimaryButton } from '@crehana/ui';

import { OrganizationSizeEnum } from '@/shared/types/graphql/globals';
import { TKeys } from '@/views/B2BLanding/pages/FreeTrial/i18n/types';

import EnterpriseLogo from './logos/EnterpriseLogo';
import LargeCommercialLogo from './logos/LargeCommercialLogo';
import MiddleCommercialLogo from './logos/MiddleCommercialLogo';
import SmallBusinessLogo from './logos/SmallBusinessLogo';
import Option from './Option';
import { CompanyDataType, CompanySizeProps } from './types';

const OptionWrapper = styled.div`
  max-width: 448px;
  @media (min-width: 1024px) {
    max-width: 100%;
  }
`;

const DATA: CompanyDataType[] = [
  {
    value: OrganizationSizeEnum.SIZE_MAX_250,
    label: 'TRIAL_FORM_COMPANY_SIZE_1',
    logo: (isSelected: boolean) => (
      <SmallBusinessLogo isSelected={isSelected} />
    ),
  },
  {
    value: OrganizationSizeEnum.SIZE_MAX_1000,
    label: 'TRIAL_FORM_COMPANY_SIZE_2',
    logo: (isSelected: boolean) => (
      <MiddleCommercialLogo isSelected={isSelected} />
    ),
  },
  {
    value: OrganizationSizeEnum.SIZE_MORE_THAN_1000,
    label: 'TRIAL_FORM_COMPANY_SIZE_3',
    logo: (isSelected: boolean) => (
      <LargeCommercialLogo isSelected={isSelected} />
    ),
  },
  {
    value: OrganizationSizeEnum.SIZE_MORE_THAN_5000,
    label: 'TRIAL_FORM_COMPANY_SIZE_4',
    logo: (isSelected: boolean) => <EnterpriseLogo isSelected={isSelected} />,
  },
];

const CompanySize: FC<React.PropsWithChildren<CompanySizeProps>> = ({
  nextStep,
  setCompanySize,
  className,
}) => {
  const [option, setOption] = useState({
    value: '',
    label: '',
  });
  const { t } = useTranslation<TKeys>();

  return (
    <div className={`${className} m-auto`}>
      <OptionWrapper className="flex flex-col md:flex-row w-full mx-auto">
        {DATA.map(({ value, label, logo: businessLogo }, index) => (
          <Option
            onClick={() => {
              setOption({ value, label: t(label) });
              setCompanySize({ value, label: t(label) });
            }}
            key={value}
            businessLogo={businessLogo}
            isSelected={value === option.value}
            label={t(label)}
            isLastItem={DATA.length === index + 1}
          />
        ))}
      </OptionWrapper>
      <div className="mt-40 w-full text-center">
        <PrimaryButton
          className="w-full sm:w-280 sm:m-auto font-poppins font-semibold text-16 rounded-10"
          size="l"
          full
          label={t('FORM_BY_STEPS_NEXT_BUTTON')}
          disabled={!option.value}
          onClick={nextStep}
          isDark
        />
      </div>
    </div>
  );
};

export default CompanySize;
